import React from "react";

const VARIANTS = {
  gray: "bg-gray-100 text-gray-700",
  green: "bg-green-100 text-green-700",
  red: "bg-red-100 text-red-700",
  amber: "bg-amber-100 text-amber-800",
  blue: "bg-blue-100 text-blue-700",
  orange: "bg-orange-100 text-orange-700",
};

export default function Badge({ children, variant = "gray", className = "" }) {
  const base = "inline-flex items-center px-2 py-0.5 rounded text-xs font-medium";
  const v = VARIANTS[variant] || VARIANTS.gray;
  return <span className={`${base} ${v} ${className}`}>{children}</span>;
}

